import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=38840c96"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=38840c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports